import { render, staticRenderFns } from "./Moderate.vue?vue&type=template&id=244c5708&scoped=true&"
import script from "./Moderate.vue?vue&type=script&lang=js&"
export * from "./Moderate.vue?vue&type=script&lang=js&"
import style0 from "./Moderate.vue?vue&type=style&index=0&id=244c5708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c5708",
  null
  
)

export default component.exports